import { useCallback, useEffect, useRef, useState } from 'react';

/** Right-edge fade for a scrolling control row - true only while there is more to reach. */
export function useHorizontalOverflow(revision?: unknown) {
  const ref = useRef<HTMLDivElement | null>(null);
  const [faded, setFaded] = useState(false);

  const measure = useCallback(() => {
    const el = ref.current;
    if (!el) return;
    setFaded(el.scrollWidth - el.clientWidth - el.scrollLeft > 1);
  }, []);

  useEffect(() => {
    measure();
    window.addEventListener('resize', measure, false);
    return () => window.removeEventListener('resize', measure, false);
  }, [measure, revision]);

  return { ref, faded, measure };
}
